(() => {
  if (customElements.get('senza-card-media')) return;

  customElements.define('senza-card-media', class extends HTMLElement {
    get secondary() {
      return this.querySelector('.product-card__image--secondary');
    }

    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      if (!this.secondary) return;

      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse' && matchMedia('(hover: hover) and (pointer: fine)').matches) {
          this.preview();
        }
      }, options);
      this.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') this.reset();
      }, options);
      this.addEventListener('pointerdown', (event) => {
        this.suppressSwipeClick = false;
        this.swipe = event.isPrimary && event.pointerType === 'touch'
          ? { id: event.pointerId, x: event.clientX, y: event.clientY, vertical: false }
          : null;
      }, options);
      this.addEventListener('pointermove', (event) => {
        const swipe = this.swipe;
        if (!swipe || swipe.id !== event.pointerId) return;
        const dx = Math.abs(event.clientX - swipe.x);
        const dy = Math.abs(event.clientY - swipe.y);
        if (dy > 10 && dy > dx) swipe.vertical = true;
      }, { ...options, passive: true });
      this.addEventListener('pointercancel', () => { this.swipe = null; }, options);
      this.addEventListener('pointerup', (event) => {
        const swipe = this.swipe;
        this.swipe = null;
        if (!swipe || swipe.id !== event.pointerId || swipe.vertical) return;
        const dx = event.clientX - swipe.x;
        const dy = event.clientY - swipe.y;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        this.suppressSwipeClick = true;
        dx < 0 ? this.preview() : this.reset();
      }, options);
      this.addEventListener('click', (event) => {
        if (!this.suppressSwipeClick || event.detail === 0) return;
        this.suppressSwipeClick = false;
        event.preventDefault();
        event.stopPropagation();
      }, options);

    }

    preview() {
      const image = this.secondary;
      if (!image) return;
      this.wantsPreview = true;
      image.loading = 'eager';
      image.setAttribute('aria-hidden', 'true');
      const show = () => {
        if (this.wantsPreview && image === this.secondary && image.naturalWidth > 0) this.setAttribute('data-preview', '');
      };
      if (image.complete) show();
      else image.addEventListener('load', show, { once: true, signal: this.controller.signal });
    }

    reset() {
      this.wantsPreview = false;
      this.removeAttribute('data-preview');
    }

    disconnectedCallback() {
      this.reset();
      this.controller?.abort();
    }
  });
})();
